export default {
    // 添加扩展组信息
    insertExtendGroup(params, response) {
        return window.vue.$apiAxios.postRequestBody('/extendManage/insertExtendGroup', params, response);
    },
    // 更新扩展组信息
    updateExtendGroup(params, response) {
        return window.vue.$apiAxios.postRequestBody('/extendManage/updateExtendGroup', params, response);
    },
    // 删除扩展组信息
    deleteExtendGroup(params, response) {
        return window.vue.$apiAxios.get('/extendManage/deleteExtendGroup', params, response);
    },
    // 查询扩展组中扩展元素信息接口
    listGroupElementInfo(params, response) {
        return window.vue.$apiAxios.postRequestBody('/extendManage/listGroupElementInfo', params, response);
    },
    // 向扩展组中添加扩展元素信息
    insertGroupElement(params, response) {
        return window.vue.$apiAxios.postRequestBody('/extendManage/insertGroupElement', params, response);
    },
    // 更新扩展组中的扩展元素信息
    updateGroupElement(params, response) {
        return window.vue.$apiAxios.postRequestBody('/extendManage/updateGroupElement', params, response);
    },
    // 删除扩展组中的扩展元素信息
    deleteGroupElement(params, response) {
        return window.vue.$apiAxios.postRequestBody('/extendManage/deleteGroupElement', params, response);
    },
    // 查询扩展元素信息接口
    listExtendElementInfo(params, response) {
        return window.vue.$apiAxios.postRequestBody('/extendManage/listExtendElementInfo', params, response);
    },
    // 查询扩展组信息接口
    listExtendGroupInfos(params, response) {
        return window.vue.$apiAxios.postRequestBody('/extendManage/findExtendGroupTree', params, response);
    },
    // 查询扩展详细信息
    queryExtendInfo(params, response) {
        return window.vue.$apiAxios.get('/extendManage/queryExtendInfo', params, response);
    },
    //检测扩展组标识或扩展组名称是否存在
    checkGroupInfo(params, response) {
        return window.vue.$apiAxios.postRequestBody('/extendManage/checkGroupInfo', params, response);
    },
    //获取最大扩展排序值
    getMaxExtendOrder(params, response) {
        return window.vue.$apiAxios.get('/extendManage/getMaxExtendOrder', params, response);
    },
    // 查询扩展属性
    queryElementPropsByType(params, response) {
        return window.vue.$apiAxios.postRequestBody('/extendManage/queryElementPropsByType', params, response);
    },
    // 查询控件事件
    queryElementEventsByType(params, response) {
        return window.vue.$apiAxios.postRequestBody('/extendManage/queryElementEventsByType', params, response);
    },
    // 保存扩展元素值
    insertExtendValue(params, response) {
        return window.vue.$apiAxios.postRequestBody('/extendManage/insertExtendValue', params, response);
    },
    // 查询预览效果扩展元素值
    queryExtendValue(params, response) {
        return window.vue.$apiAxios.get('/extendManage/queryExtendValue', params, response);
    },
    // 检测扩展组中元素关键字是否重复
    checkElementKey(params, response) {
        return window.vue.$apiAxios.postRequestBody('/extendManage/checkElementKey', params, response);
    },
    // 更新元素显示顺序
    updateSortInfo(params, response) {
        return window.vue.$apiAxios.postRequestBody('/extendManage/updateSortInfo', params, response);
    },
    // 更新元素显示顺序
    listExtendInfo(params, response) {
        return window.vue.$apiAxios.postRequestBody('/extendManage/listExtendInfo', params, response);
    }
};
